import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { ProfilesHeader } from '../components/ProfilesHeader';
import { Environment } from '../components/settings/Environment';
import { ChildProfiles } from '../components/settings/ChildProfiles';
import { profilesTabsConfig, type ProfilesTab, isValidProfilesTab, getProfilesTabsWithHrefs } from '../config/profilesTabs';

export function ProfilesPage() {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<ProfilesTab>('students');

  useEffect(() => {
    // Extract tab from URL path
    const pathSegments = location.pathname.split('/');
    const tabFromPath = pathSegments[pathSegments.length - 1];
    
    // If we're at /app/profiles (no specific tab), default to students
    if (tabFromPath === 'profiles') {
      setActiveTab('students');
    } else if (tabFromPath && isValidProfilesTab(tabFromPath)) {
      setActiveTab(tabFromPath);
    }
  }, [location.pathname]);

  const tabs = getProfilesTabsWithHrefs(activeTab);

  const renderTabContent = () => {
    switch (activeTab) {
      case 'environment':
        return <Environment />;
      case 'students':
        return <ChildProfiles />;
      default:
        return null;
    }
  };

  return (
    <div className="p-4 sm:p-6">
        <ProfilesHeader 
          tabs={tabs}
          activeTab={activeTab}
          onTabChange={setActiveTab}
        >
          {renderTabContent()}
        </ProfilesHeader>
      </div>
  );
}

